const parseGraphqlErrorMessage = (err: any) => {
  return err[0].message.message || err[0].message;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  parseGraphqlErrorMessage,
};
